import { ContentSummary, ContentType } from '../../core/models';

export interface NewsCardData {
  id: string;
  title: string;
  summary: string;
  categoryLabelKey: string;
  accentClass: string;
  categoryTextClass: string;
  publishedAt: string | null;
  imageUrl: string | null;
  coverMediaId: string | null;
}

/** type de contenu (content-service) → clé i18n (`content.types.*`) et couleur d'accent de la maquette "Actualités". */
const TYPE_META: Record<ContentType, { labelKey: string; accentClass: string; textClass: string }> = {
  NEWS: { labelKey: 'content.types.news', accentClass: 'bg-(--ycc-rouge)', textClass: 'text-(--ycc-rouge)' },
  PROGRAM: { labelKey: 'content.types.program', accentClass: 'bg-(--ycc-bleu-ciel)', textClass: 'text-(--ycc-bleu-ciel)' },
  SUCCESS_STORY: { labelKey: 'content.types.successStory', accentClass: 'bg-(--ycc-vert)', textClass: 'text-(--ycc-vert)' },
  TRAINING: { labelKey: 'content.types.training', accentClass: 'bg-(--ycc-bleu-ciel)', textClass: 'text-(--ycc-bleu-ciel)' },
  GUIDE: { labelKey: 'content.types.guide', accentClass: 'bg-(--ycc-vert)', textClass: 'text-(--ycc-vert)' },
  RESOURCE: { labelKey: 'content.types.resource', accentClass: 'bg-(--ycc-vert)', textClass: 'text-(--ycc-vert)' },
  PAGE: { labelKey: 'content.types.information', accentClass: 'bg-(--pnud-bleu)', textClass: 'text-(--pnud-bleu)' },
  HOME_SECTION: { labelKey: 'content.types.information', accentClass: 'bg-(--pnud-bleu)', textClass: 'text-(--pnud-bleu)' },
};

export function toNewsCardData(content: ContentSummary): NewsCardData {
  const meta = TYPE_META[content.type];
  return {
    id: content.id,
    title: content.title,
    summary: content.summary ?? '',
    categoryLabelKey: meta.labelKey,
    accentClass: meta.accentClass,
    categoryTextClass: meta.textClass,
    publishedAt: content.publishedAt,
    imageUrl: content.coverThumbnailUrl ?? content.coverUrl,
    coverMediaId: content.coverMediaId,
  };
}
